module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<thead>\n <tr>\n  <th>Date</th>\n  <th>Bill</th>\n  <th>Description</th>\n  <th class="text-end">Vote</th>\n </tr>\n</thead>\n<tbody></tbody>\n';
}
return __p;
};
